import React from 'react';
import { PageHeader } from '../components/ui/PageHeader';
import { ContactCTA } from '../components/ContactCTA';
import { useSeo } from '../hooks/useSeo';
import { InserJeunes } from '../components/InserJeunes';
import { FORMATIONS } from '../data/constants';
import { SectionHeading } from '../components/ui/SectionHeading';
import { StatCard } from '../components/StatCard';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Award, Download, CheckCircle, Star, Target, ShieldAlert, TrendingUp, Clock } from 'lucide-react';
export function Qualite() {
  const tpCv = FORMATIONS.find(f => f.id === 'tp-conseiller-vente');
  const bts = FORMATIONS.find(f => f.id === 'bts-ndrc');
  useSeo({
    title: 'Qualité, Qualiopi et indicateurs de résultats',
    description: "Zillenium Alternance est certifié Qualiopi pour ses actions de formation et de formation par apprentissage. Consultez nos indicateurs de résultats, nos engagements qualité et nos certificats téléchargeables.",
    path: '/qualite'
  });
  return <div className="flex flex-col w-full" data-id="element-2383" data-mp="1q34v3vbwzp75">
      <PageHeader title="Qualité et Transparence" subtitle="Zillenium Alternance s'engage dans une démarche d'amélioration continue pour garantir l'excellence de ses formations." data-id="element-2384" data-mp="1q464zwh725na" />

      {/* Intro */}
      <section className="py-16 md:py-24 bg-white" data-id="element-2385" data-mp="2dz8w6b3h0l6x">
        <div className="container max-w-4xl mx-auto text-center" data-id="element-2386" data-mp="2dxxr87yah7e8">
          <p className="text-xl md:text-2xl text-muted-foreground leading-relaxed font-medium" data-id="element-2387" data-mp="28zmmucqrjp3e">
            Notre démarche qualité place l'apprenant et l'entreprise au cœur de
            nos préoccupations. Nous mesurons régulièrement nos performances
            afin d'adapter nos méthodes pédagogiques et de répondre aux
            exigences du référentiel national qualité.
          </p>
        </div>
      </section>

      {/* Certificats Qualiopi */}
      <section className="py-24 bg-muted relative overflow-hidden" data-id="element-2388" data-mp="1pdrbnrx6uoqv">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-orange rounded-full blur-[100px] opacity-10 pointer-events-none" data-id="element-2389" data-mp="1pflu8zkzm4rs" />
        <div className="container max-w-5xl mx-auto relative z-10" data-id="element-2390" data-mp="1yepck1cbyg58">
          <SectionHeading title="Nos certifications Qualiopi" centered data-id="element-2391" data-mp="1yccrvgf6troh" />
          <div className="grid md:grid-cols-2 gap-10 mt-16" data-id="element-2392" data-mp="236qofm5l64uq">
            <Card className="border-none shadow-xl hover:-translate-y-2 transition-all duration-300 bg-white group" data-id="element-2393" data-mp="284s745z3o25o">
              <div className="h-2 w-full bg-primary" data-id="element-2394" data-mp="2d2aj658eyxhw" />
              <CardHeader className="pt-8 pb-4" data-id="element-2395" data-mp="2h4xewh87h2kd">
                <div className="w-16 h-16 bg-lavande rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-2396" data-mp="2h68ioh1niabh">
                  <Award className="w-8 h-8 text-primary animate-soft-pulse" data-id="element-2397" data-mp="mr5x2ufq3cdu" />
                </div>
                <CardTitle className="text-2xl font-extrabold font-heading text-primary-dark" data-id="element-2398" data-mp="rpquyn7i5jz4">
                  Formation par apprentissage
                </CardTitle>
              </CardHeader>
              <CardContent data-id="element-2399" data-mp="fg1b9iqh2frx">
                <p className="text-lg text-muted-foreground mb-8" data-id="element-2400" data-mp="feq6bflaj1z8">
                  Certifié par CAPCERT. Valable jusqu'au 30/10/2027.
                </p>
                <Button variant="outline" className="w-full border-primary/20 text-primary-dark hover:bg-primary/5 font-semibold" asChild data-id="element-2401" data-mp="aec0m475w44d">
                  <a href="https://cdn.magicpatterns.com/uploads/uxuWAaU2vHtjX7ZhfSq9Aw/Capture_d’ecran_2026-06-21_a_19.37.57.png" target="_blank" rel="noopener noreferrer" data-id="element-2402" data-mp="y6inmcqzyyr4">
                    <Download className="w-5 h-5 mr-2" data-id="element-2403" data-mp="p518oxpbt340" />
                    Télécharger le certificat
                  </a>
                </Button>
              </CardContent>
            </Card>

            <Card className="border-none shadow-xl hover:-translate-y-2 transition-all duration-300 bg-white group" data-id="element-2404" data-mp="39u8jvt11f8er">
              <div className="h-2 w-full bg-brand-orange" data-id="element-2405" data-mp="11l0q1j2rrax2" />
              <CardHeader className="pt-8 pb-4" data-id="element-2406" data-mp="16evipc0cr08a">
                <div className="w-16 h-16 bg-lavande rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-2407" data-mp="16fn45u08jhku">
                  <Award className="w-8 h-8 text-brand-orange animate-soft-pulse" data-id="element-2408" data-mp="wosiaqqwijzx" />
                </div>
                <CardTitle className="text-2xl font-extrabold font-heading text-primary-dark" data-id="element-2409" data-mp="1ke4n7ef745wf">
                  Actions de formation
                </CardTitle>
              </CardHeader>
              <CardContent data-id="element-2410" data-mp="1bc54mhoj8trd">
                <p className="text-lg text-muted-foreground mb-8" data-id="element-2411" data-mp="1bezp297jqeks">
                  Certifié par CAPCERT. Valable jusqu'au 01/09/2027.
                </p>
                <Button variant="outline" className="w-full border-primary/20 text-primary-dark hover:bg-primary/5 font-semibold" asChild data-id="element-2412" data-mp="3w2w3vps56eeg">
                  <a href="https://cdn.magicpatterns.com/uploads/2eVnp5Bk4nD8NeVbW5n73A/Capture_d’ecran_2026-06-21_a_19.38.12.png" target="_blank" rel="noopener noreferrer" data-id="element-2413" data-mp="3sk6pouknf98w">
                    <Download className="w-5 h-5 mr-2" data-id="element-2414" data-mp="1ex91tijo7by" />
                    Télécharger le certificat
                  </a>
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Indicateurs de résultats */}
      <section id="indicateurs" className="py-24 bg-white relative overflow-hidden" data-id="element-2415" data-mp="34tj79fd3x183">
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-primary rounded-full blur-[100px] opacity-10 pointer-events-none" data-id="element-2416" data-mp="3jmcz809kf9tn" />
        <div className="container max-w-6xl mx-auto relative z-10" data-id="element-2417" data-mp="2r3frn78qg5rm">
          <SectionHeading title="Nos indicateurs de résultats réels" centered data-id="element-2418" data-mp="2m55vouf6p14y" />

          <div className="space-y-20 mt-16" data-id="element-2419" data-mp="2m31rschac24o">
            <div data-id="element-2420" data-mp="3bu36t2qx6f90">
              <h3 className="text-3xl font-extrabold font-heading mb-10 text-center text-primary-dark" data-id="element-2421" data-mp="3bsibvc0p0uam">
                TP Conseiller de Vente{' '}
                <span className="text-primary font-medium text-2xl block mt-2" data-id="element-2422" data-mp="3kllm7bg1kr11">
                  (Session 2024/2025)
                </span>
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-2423" data-mp="3pk6mtbz7hcq0">
                <StatCard value="100%" label="Réussite" icon={<CheckCircle className="w-8 h-8" data-id="element-2425" data-mp="2wx2gn3odmscn" />} data-id="element-2424" data-mp="2svh27dw7260c" />
                <StatCard value="97%" label="Satisfaction" icon={<Star className="w-8 h-8" data-id="element-2427" data-mp="36uq9fo2f9ps6" />} data-id="element-2426" data-mp="31ukp6syhf5k4" />
                <StatCard value="60%" label="Présentation examen" icon={<Target className="w-8 h-8" data-id="element-2429" data-mp="h797qvfxl825" />} data-id="element-2428" data-mp="36s45dyeqpsep" />
                <StatCard value="40%" label="Rupture" icon={<ShieldAlert className="w-8 h-8" data-id="element-2431" data-mp="26lh44lhe7oce" />} data-id="element-2430" data-mp="m2eprj67q2ky" />
              </div>
              <p className="text-center text-lg text-muted-foreground mt-8 font-medium" data-id="element-2432" data-mp="21o8i29t4j05v">
                Suites de parcours : 60% poursuite d'études / 40% emploi
              </p>
              {tpCv?.inserJeunes && <div className="mt-12 max-w-4xl mx-auto" data-id="element-2433" data-mp="1rwuenqy1xg7g">
                  <InserJeunes data={tpCv.inserJeunes} data-id="element-2434" data-mp="1nvsn7wadm8g1" />
                </div>}
            </div>

            <div className="max-w-4xl mx-auto" data-id="element-2435" data-mp="1ivecg6he4keb">
              <h3 className="text-3xl font-extrabold font-heading mb-10 text-center text-primary-dark" data-id="element-2436" data-mp="1iysgrk9m73oe">
                BTS NDRC{' '}
                <span className="text-primary font-medium text-2xl block mt-2" data-id="element-2437" data-mp="18z1mnjoyuqou">
                  (Enquête mai 2026)
                </span>
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2438" data-mp="38901g9rvai16">
                <StatCard value="94%" label="Satisfaction globale" icon={<TrendingUp className="w-8 h-8" data-id="element-2440" data-mp="2c7p2442jj6wu" />} data-id="element-2439" data-mp="33csqu3oj0icw" />
                <Card className="bg-muted border-none flex items-center justify-center p-8 text-center shadow-inner" data-id="element-2441" data-mp="2h4yqdge71cj3">
                  <span className="text-lg text-muted-foreground font-medium" data-id="element-2442" data-mp="23e3myjmgrnmw">
                    Résultats aux examens attendus en 2027
                  </span>
                </Card>
              </div>
              {bts?.inserJeunes && <div className="mt-12" data-id="element-2443" data-mp="1yf8wcvi98us8">
                  <InserJeunes data={bts.inserJeunes} data-id="element-2444" data-mp="1ygbmv2bo0v7m" />
                </div>}
            </div>

            <div className="max-w-4xl mx-auto" data-id="element-2445" data-mp="1khbx1rcf2a9v">
              <h3 className="text-3xl font-extrabold font-heading mb-10 text-center text-primary-dark" data-id="element-2446" data-mp="1oh2v8g49vsof">
                TP Négociateur Technico-Commercial{' '}
                <span className="text-primary font-medium text-2xl block mt-2" data-id="element-2447" data-mp="3eujuzrvov1zq">
                  (Session 2026/2027)
                </span>
              </h3>
              <Card className="border-none shadow-lg bg-white overflow-hidden" data-id="element-2448" data-mp="1778sbduy9fnb">
                <div className="h-2 w-full bg-brand-orange" data-id="element-2449" data-mp="136oue82jy804" />
                <CardContent className="p-8 md:p-12 text-center" data-id="element-2450" data-mp="134c2b232yh9c">
                  <div className="w-16 h-16 bg-lavande rounded-2xl flex items-center justify-center mx-auto mb-6" data-id="element-2451" data-mp="1gyv71k6hxwut">
                    <Clock className="w-8 h-8 text-brand-orange animate-soft-pulse" data-id="element-2452" data-mp="1c5k25ol8vq5j" />
                  </div>
                  <span className="inline-block bg-brand-orange/10 text-brand-orange text-xs font-bold uppercase tracking-wider px-4 py-1.5 rounded-full mb-4" data-id="element-2453" data-mp="1qu6fxlv849un">
                    Formation en cours
                  </span>
                  <h4 className="text-2xl font-extrabold font-heading text-primary-dark mb-4" data-id="element-2454" data-mp="1uxl798om4cne">
                    Indicateurs en cours de constitution
                  </h4>
                  <p className="text-lg text-muted-foreground leading-relaxed max-w-2xl mx-auto" data-id="element-2455" data-mp="5iwuh6c40sou">
                    La session démarre en <strong data-id="element-2456" data-mp="lxzklkmghpl">septembre 2026</strong>. Aucune
                    promotion n'étant encore arrivée à son terme, les taux de
                    réussite, de satisfaction et d'insertion seront publiés à
                    l'issue du premier jury, conformément à notre engagement de
                    transparence.
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>

      {/* Contact direct */}
      <section className="py-24 bg-white" data-id="element-2457" data-mp="qdfiy3g52st9">
        <div className="container max-w-6xl mx-auto" data-id="element-2458" data-mp="m9herebyirtc">
          <ContactCTA title="Une question sur nos résultats ou nos engagements ?" subtitle="Nous répondons en toute transparence sur nos indicateurs, notre certification Qualiopi et notre accompagnement. Appelez-nous." action={{
          label: 'Consulter nos documents qualité',
          to: '/documents'
        }} data-id="element-2459" data-mp="mbu4wervc8hh" />
        </div>
      </section>
    </div>;
}